import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class BillingConfigurationOwnershipBillingActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Property/OwnershipBillingPreset/OwnershipBillingPresetBrowser")
	}

	render() {
		return (
			<Activity 
				name="BillingConfigurationOwnershipBilling"
				RenderedComponent={this.RenderedComponent}
				context="BillingConfigurationOwnershipBilling"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(BillingConfigurationOwnershipBillingActivity)
